// extracted by mini-css-extract-plugin
module.exports = {"list-bottom":"UserMenu_list-bottom__l75M5","btn-user":"UserMenu_btn-user__3vUxb","userName":"UserMenu_userName__T2PZe"};